import LoginForm from '../forms/login-form';

export default function LoginPage() {
  return (
    <div className="flex size-full h-full items-center justify-center">
      <LoginForm />
    </div>
  );
}
